import LearningProgress from "./components/learning/LearningProgress";
import ListCourse from "./components/learning/ListCourse";
import NewCourse from "./components/learning/pages/NewCourse";
import styles from "./styles/Dashboard.module.css";
import { useCourseProgressQuery, useCoursesQuery } from "./hooks/useCourse";
import Layout from "./components/ui/Layout";
import { useSearchParams } from "react-router-dom";

export const LearnPage = () => {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category");

  // 4. Call the new hooks to get data and loading states
  const { data: courses = [], isLoading: loadingCourses } =
    useCoursesQuery(categoryId);
  const { data: progressData } = useCourseProgressQuery(categoryId);

  // 5. Derive state from the progress query's result
  const ongoingContents = progressData?.ongoingContents || [];
  const ongoingAverageProgress = progressData?.ongoingAverageProgress || 0;

  // All manual useState and useEffect hooks for data fetching are now removed.

  return (
    <Layout>
      <div>
        <div>
          <h1 className="text-2xl md:text-3xl text-left font-bold capitalize text-gray-900 mb-4">
            Learning Center : {categoryId}
          </h1>
          <div className="bg-[#E6EAF9] p-4 rounded-xl">
            <LearningProgress
              ongoingAverageProgress={ongoingAverageProgress}
              modulesLeft={ongoingContents?.length}
            />
            <NewCourse courses={ongoingContents} loading={loadingCourses} />
          </div>
          <ListCourse
            courses={courses}
            loading={loadingCourses}
            ongoingContents={ongoingContents}
          />
        </div>
      </div>
    </Layout>
  );
};
